// MUI
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import React, { Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import theme from '../utils/theme';
// Components
import Auth from './Landing/Auth';
import Login from './Landing/Auth/Login';
import Signup from './Landing/Auth/Signup';
import Strapline from './Landing/Strapline';
import MarketSearch from './MarketSearch';
import Asset from './MarketSearch/Asset';
import Analysis from './MarketSearch/Asset/Analysis';
import LoI from './MarketSearch/Asset/LoI';
import LoISuccess from './MarketSearch/Asset/LoI/Success';
import MyPortfolio from './MyPortfolio';
import Dashboard from './MyPortfolio/Dashboard';
import ProcessSetting from './MyPortfolio/ProcessSetting';
import LoiReport from './MyPortfolio/LoiReport';
import MyProcesses from './MyProcesses';
import QnA from './MarketSearch/QnA';
import RentRoll from './MarketSearch/RentRoll'

function App() {
	return (
		<ThemeProvider theme={theme}>
			<Fragment>
				<CssBaseline />
				<Router>
					<Switch>
						<Route exact path="/" component={Strapline} />
						<Route path="/signup" component={Signup} />
						<Route path="/login" component={Login} />
						<Route path="/auth" component={Auth} />

						<Route exact path="/my-portfolio" component={MyPortfolio} />
						<Route exact path="/market-search" component={MarketSearch} />
						<Route exact path="/my-processes" component={MyProcesses} />
						<Route exact path="/market-search/:propertyId" component={Asset} />
						<Route exact path="/market-search/:propertyId/analysis" component={Analysis} />
						<Route exact path="/market-search/:propertyId/letter-of-intent" component={LoI} />
						<Route exact path="/market-search/:propertyId/letter-of-intent/success" component={LoISuccess} />
						<Route exact path="/market-search/:id/rent-roll" component={RentRoll} />
						<Route exact path="/my-portfolio/:propertyId" component={Dashboard} />
						<Route exact path="/market-search/:id/qna" component={QnA} />
						<Route exact path="/my-portfolio/:id/process-setting" component={ProcessSetting} />
						<Route exact path="/my-portfolio/:id/loi-report" component={LoiReport} />
						<Route exact path="/my-portfolio/:id/loi-summary" component={LoiReport} />
					</Switch>
				</Router>
			</Fragment>
		</ThemeProvider>
	);
}

export default App;
